<template>
  <div>
    <banner-top title="" :show-icon-right="false" />
    <div class="errorRecovery">
      <div class="weixin_code">
        <img :src="codeImg" />
      </div>
      <div class="back_answer" @click="backAnswer">返回答案核对</div>
    </div>
  </div>
</template>
<script>
import { poststudyAllotcounselor } from '@/api/answer'
import BannerTop from '@/components/BannerTop'
export default {
  components: {
    BannerTop
  },
  data() {
    return {
      codeImg: ''
    }
  },
  async mounted() {
    await poststudyAllotcounselor({ openid: this.$store.openid }).then((res) => {
      if (res.status === 200) {
        this.codeImg = res.data.data.qrcodeUrl
      }
    })
  },
  methods: {
    backAnswer() {
      window.location.href = '/cms/webapp/home/answer/index.html'
    }
  }
}
</script>
<style lang="scss" scoped>
.errorRecovery {
  width: 100%;
  height: 80vh;
  background: url('https://img01.yzcdn.cn/upload_files/2021/03/30/FgMe3h-6I14K7GpwqlF-8MQyZXQe.png');
  background-size: 100%;
  background-color: #fff;
  position: relative;
  background-repeat: no-repeat;
  .weixin_code {
    width: 168.28px;
    height: 168.28px;
    border: 2px solid #ff9e44;
    border-radius: 5px;
    position: absolute;
    top: 185px;
    left: 50%;
    transform: translate(-50%);
    img {
      width: 165px;
      height: 165px;
    }
  }
  .back_answer {
    width: 204px;
    height: 44px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 600;
    background: linear-gradient(141.52deg, #ff4034 15.83%, #ff5c4e 82.71%);
    box-shadow: 0px 1px 4px rgba(255, 66, 60, 0.3);
    border-radius: 25px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    top: 450px;
  }
}
</style>
